import * as $ from 'jquery';

export default class ClassChangeObserver {
    private observer: MutationObserver;

    constructor(private targetSelector: string, private childSelector: string) {
        const targetElement = document.querySelector(targetSelector) as HTMLElement;

        this.observer = new MutationObserver(this.onClassChange.bind(this));

        if (targetElement) {
            this.observer.observe(targetElement, { attributes: true });
        } else {
            return;
        }
    }

    private onClassChange(mutationsList: MutationRecord[], observer: MutationObserver) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const targetElement = document.querySelector(this.targetSelector) as HTMLElement;
                if (targetElement?.classList.contains('valuesAreNotDefault')) {
                    // Perform an action on the child element
                    $(this.childSelector).slideUp();
                    // Disconnect the observer after running the code
                    observer.disconnect();
                }
            }
        }
    }
}
